import React from "react";
import { Link } from "react-router-dom";

const ServiceInclude = () => {
    return (
        <><div class="right-section-service">
            <div class="bookmarks-wrapper" aria-labelledby="icp_toc_title">
                <div className='right-section-heading'>
                    <h3>Salesforce</h3>
                </div>
                <div className="sidebar-include">
                    <ul>
                        <Link to="/salesforce/implementation"><li> Salesforce Implementation</li></Link>
                        <Link to="/salesforce/consulting"><li>Salesforce Consulting</li></Link>
                        <Link to="/salesforce/development"><li>Salesforce App Development</li></Link>
                        <Link to="/salesforce/integration"><li>Salesforce Integration</li></Link>
                        <Link to="/salesforce/support"><li>Salesforce Support</li></Link>
                        <Link to="/salesforce/maintenance"><li>Salesforce Maintenance</li></Link>
                        <Link to="/salesforce/managed"><li>Salesforce Managed</li></Link>
                        <Link to="/salesforce/customization"><li>Salesforce Customization</li></Link>
                        <Link to="/salesforce/sales-cloud"><li>Salesforce Sales Cloud</li></Link>
                        <Link to="/salesforce/service-cloud"><li>Salesforce Service Cloud</li></Link>
                        <Link to="/salesforce/marketing-cloud"><li>Salesforce Marketing Cloud</li></Link>
                        <Link to="/salesforce/commerce-cloud"><li>Salesforce Commerce Cloud</li></Link>
                        <Link to="/salesforce/community-cloud"><li>Salesforce Community Cloud</li></Link>
                        <Link to="/salesforce/non-profit"><li>Salesforce Non-Profit Cloud</li></Link>
                        <Link to="/salesforce/finencial-service-cloud"><li>Salesforce Financial Service Cloud</li></Link>
                        <Link to="/salesforce/cpq"><li>Salesforce CPQ</li></Link>
                        <Link to="/salesforce/einstein-analytics"><li>Salesforce Einstein Analytics</li></Link>
                        <br />
                    </ul>
                </div>
            </div>
        </div>

        </>
    )
}

export default ServiceInclude;